module.exports = __webpack_public_path__ + "static/img/PIK3CB_Snapshot.5af0c12.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/PIK3CB_Snapshot.png
// module id = 527
// module chunks = 1